/** CoStar.Api.LoopNet.MobileServices.ViewModels.Geographies.GeographyType */
export var GeographyType;
(function (GeographyType) {
    GeographyType[GeographyType["Unknown"] = 0] = "Unknown";
    GeographyType[GeographyType["State"] = 1] = "State";
    GeographyType[GeographyType["City"] = 2] = "City";
    GeographyType[GeographyType["PostalCode"] = 3] = "PostalCode";
    GeographyType[GeographyType["Neighborhood"] = 4] = "Neighborhood";
    GeographyType[GeographyType["Property"] = 5] = "Property";
    GeographyType[GeographyType["Residential"] = 6] = "Residential";
    GeographyType[GeographyType["Custom"] = 7] = "Custom";
    GeographyType[GeographyType["Address"] = 8] = "Address";
    GeographyType[GeographyType["County"] = 9] = "County";
    GeographyType[GeographyType["Submarket"] = 10] = "Submarket";
    GeographyType[GeographyType["GeocodeResult"] = 12] = "GeocodeResult";
    GeographyType[GeographyType["ShoppingCenter"] = 14] = "ShoppingCenter";
    GeographyType[GeographyType["Country"] = 15] = "Country";
    GeographyType[GeographyType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    GeographyType[GeographyType["Region"] = 17] = "Region";
    GeographyType[GeographyType["Metro"] = 32] = "Metro";
    GeographyType[GeographyType["PropertyGroup"] = 42] = "PropertyGroup";
})(GeographyType || (GeographyType = {}));
